import { FORM_STATE_TYPES } from './formStateActionTypes';

export const setFormIsDirty = (isDirty: boolean) => ({
  type: FORM_STATE_TYPES.SET_FORM_IS_DIRTY,
  payload: isDirty,
});
